import {delegateEvent} from '../utils/dom';

const NOTIFICATIONS_CONTAINER_SELECTOR = 'data-notifications-container';
const NOTIFICATIONS_CONTAINER_TEMPLATE = `<div class="joyv2" ${NOTIFICATIONS_CONTAINER_SELECTOR}></div>`;
const DEFAULT_NOTIFICATION_DURATION_IN_MS = 5000;
const NOTIFICATION_LEVELS = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
};

const DEFAULT_NOTIFICATION_OPTIONS = {
    level: NOTIFICATION_LEVELS.success,
    duration: DEFAULT_NOTIFICATION_DURATION_IN_MS,
    closable: true,
};

function notificationContentBuilder({level, message, id, closable, htmlExtension}) {
    return `
        <div class="c-snackbar c-snackbar_${level}" id="${id}" data-level="${level}">
            <div class="c-snackbar__img">
                ${iconAccordingToNotification(level)}
            </div>
            <div class="c-snackbar__content">
                <span>${message}</span>
                ${htmlExtension ? `${htmlExtension}` : ''}
            </div>
           ${closable ? closeFeedbackCTA() : ''}
        </div> 
    `;
}

function closeFeedbackCTA() {
    return `
        <button data-close-notification type="button" class="c-snackbar__close m-icon-button">
            <i class="joy-i joy-i_no-animation joy-i_xsmall" data-js="{svg-icon: {name: 'cross'}}"></i>
        </button>
    `;
}

function iconAccordingToNotification(level) {
    let iconName = '';
    let iconColorClass = '';

    switch (level) {
        case 'error':
            iconName = 'mood-bad';
            iconColorClass = 'joy-i_red';
            break;
        case 'success':
            iconName = 'mood-good';
            iconColorClass = 'joy-i_green';
            break;
        case 'warning':
            iconName = 'info-circle';
            iconColorClass = 'joy-i_yellow';
            break;
        default:
            iconName = 'info-circle'; // default value
    }

    return `<i class="joy-i joy-i_small joy-i_no-animation ${iconColorClass}" data-js="{svg-icon: {name: '${iconName}'}}"></i>`;
}

function containerElement() {
    return document.body.querySelector(`[${NOTIFICATIONS_CONTAINER_SELECTOR}]`);
}

class NotificationService {
    constructor() {
        this.notificationServiceId = Date.now();
        this.notificationIdx = -1;
        this.setUpNotificationContainer();
    }

    get notificationToBeDisplayedId() {
        return `notification_${this.notificationIdx}`;
    }

    getDefaultNotificationOptions() {
        return DEFAULT_NOTIFICATION_OPTIONS;
    }

    getNotificationContentBuilder({message, level, id, closable, htmlExtension}) {
        return notificationContentBuilder({message, level, id, closable, htmlExtension});
    }

    generateNewNotificationId() {
        this.notificationIdx = this.notificationIdx + 1;

        return this.notificationToBeDisplayedId;
    }

    setUpNotificationContainer() {
        if (!containerElement()) {
            document.body.insertAdjacentHTML('beforeend', NOTIFICATIONS_CONTAINER_TEMPLATE);
        }
        this.container = containerElement();

        this.addListeners();
    }

    push(message, {level = DEFAULT_NOTIFICATION_OPTIONS.level, duration = DEFAULT_NOTIFICATION_OPTIONS.duration, closable = DEFAULT_NOTIFICATION_OPTIONS.closable} = DEFAULT_NOTIFICATION_OPTIONS) {
        const id = this.generateNewNotificationId();

        const notificationContent = notificationContentBuilder({message, level, id, closable});

        this.display(notificationContent);
        this.setUpLifeDuration(id, duration);

        return {
            id,
            message,
            level,
            duration,
            closable,
        };
    }

    display(content) {
        this.container.innerHTML = content;
    }

    setUpLifeDuration(id, duration) {
        setTimeout(() => {
            this.deleteNotificationElement(id);
        }, duration);
    }

    deleteNotificationElement(id) {
        const notificationElement = this.getNotificationItemById(id);
        if (notificationElement) {
            notificationElement.remove();
        }
    }

    getNotificationItemById(id) {
        return this.container.querySelector(`#${id}`);
    }

    addListeners() {
        this.listenToCloseActions();
    }

    listenToCloseActions() {
        delegateEvent(this.container, 'click', '[data-close-notification]', (e) => {
            e.target.closest('.c-snackbar').remove();
        });
    }

    clear() {
        this.container.innerHTML = '';
    }
}

export {NotificationService};
